import { render, staticRenderFns } from "./AufagbenVerwaltungInternal.vue?vue&type=template&id=6e87f941&scoped=true"
import script from "./AufagbenVerwaltungInternal.vue?vue&type=script&lang=js"
export * from "./AufagbenVerwaltungInternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e87f941",
  null
  
)

export default component.exports